import { CommApiInstance } from "Utils/CommApiInstance";

const MembQnaCtxtApi = async (
    gameSvcCd:string|null,
    qnaSno:string|null,
) => {
    return await CommApiInstance.post(`memb/qna/${gameSvcCd}/${qnaSno}`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembQnaCtxtApi;